import React from "react";
import { MDBDataTableV5 } from "mdbreact";

export default function AppDataTable({ data, ...props }) {
  return (
    <MDBDataTableV5
      className="app-data-table"
      theadColor="teal"
      theadTextWhite
      responsive
      striped
      hover
      searching
      searchTop
      searchBottom={false}
      pagingTop
      searchLabel="ค้นหา"
      entrieslabel="แสดง"
      infoLabel={["แสดง", "ถึง", "จาก", "รายการ"]}
      noRecordsFoundLabel="ไม่พบข้อมูล"
      entries={30}
      entriesOptions={[10, 20, 30, 50, 100]}
      data={data}
      {...props}
    />
  );
}
